// about.js or services.js
import React from "react";
import Home2 from "../components/Home2"
import Home3 from "../components/Home3"

export default function ServicesPage() {
  return (
    <>
      
      <Home2 />
      <Home3 />
      {/* Footer comes from your layout */}
    </>
  );
}
